<template>
  <div class="wrap text-center mt-3 searchinput-wrap">
    <h4 class="mb-3 mb-sm-0 mb-sm-2 mb-xl-0 header_desc">
      {{ cpLang('homepage.browser_by') }}
    </h4>
    <div class="container">
      <div class="row search-filt">
        <div v-click-outside="() => { showArd1 = false }" class="col-6">
          <b-card no-body class="mb-1 border-0">
            <b-card-header header-tag="header" class="p-1 shadow-none" role="tab">
              <b-button ref="ard1" @click="showArd1 = !showArd1" block variant="light">
                {{ cpLang('global.industries') }}<i :class="{'fa-chevron-down': !showArd1, 'fa-chevron-up': showArd1}" class="fas" />
              </b-button>
            </b-card-header>
            <div id="showArd1" :class="{'show': showArd1}" class="result-wrap">
              <h3 class="d-block d-sm-none inner-title">
                {{ cpLang('global.industries') }}
                <i @click="showArd1 = false" class="fa fa-times" />
                <div class="clear-both" />
              </h3>
              <div class="search-wrap">
                <input @keyup="filterStr('indlist')" @focus="showIcon = false" @blur="showIcon = true && indText === ''" v-model="indText" type="text">
                <i v-show="showIcon || indText === ''" class="fas fa-search" />
              </div>
              <div class="collaspe-wrap">
                <ul class="indlist list-group">
                  <li v-for="(i, idx) in dIndustry" :key="i.desc+'-'+idx" class="list-group-item border-0 py-1 text-left px-0">
                    <a :href="`industry/${i.slug}-jobs/1`">{{ cpLang(i.desc) }}</a>
                  </li>
                </ul>
              </div>
            </div>
          </b-card>
        </div>
        <div v-click-outside="() => { showArd2 = false }" class="col-6">
          <b-card no-body class="mb-1 border-0">
            <b-card-header header-tag="header" class="p-1 shadow-none" role="tab">
              <b-button ref="ard2" @click="showArd2 = !showArd2" block variant="light">
                {{ cpLang('global.job_function') }}<i :class="{'fa-chevron-down': !showArd2, 'fa-chevron-up': showArd2}" class="fas" />
              </b-button>
            </b-card-header>
            <div id="showArd2" :class="{'show': showArd2}" role="tabpanel" class="result-wrap">
              <h3 class="d-block d-sm-none inner-title">
                {{ cpLang('global.job_function') }}
                <i @click="showArd2 = false" class="fa fa-times" />
                <div class="clear-both" />
              </h3>
              <div class="search-wrap">
                <input @keyup="filterStr('jobfunlist')" @focus="showIcon = false" @blur="showIcon = true && jobText === ''" v-model="jobText" type="text">
                <i v-show="showIcon || jobText === ''" class="fas fa-search" />
              </div>
              <div class="collaspe-wrap">
                <ul class="jobfunlist list-group">
                  <li v-for="(i, idx) in dJobfunction" :key="i.desc+'-'+idx" class="list-group-item border-0 py-1 text-left px-0">
                    <a>{{ cpLang(i.desc) }}</a>
                    <ul v-if="i.sub">
                      <li v-for="(subi, subidx) in i.sub" :key="subi.desc+'-'+subidx">
                        <a :href="`jobs/${i.slug}/${subi.slug}/1`">{{ cpLang(subi.desc) }}</a>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </div>
          </b-card>
        </div>
        <div class="clear-both" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dIndustry: {
      type: Array,
      default: null
    },
    dJobfunction: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      showArd1: false,
      showArd2: false,
      showIcon: true,
      indText: '',
      jobText: ''
    }
  },
  methods: {
    filterStr: function(data) {
      const vm = this
      const listData = data === 'indlist' ? document.querySelectorAll('.indlist li') : document.querySelectorAll('.jobfunlist li')
      listData.forEach(function(e, i, a) {
        const filtStr = e.innerText.toLowerCase()
        const filtVal = data === 'indlist' ? vm.indText.toLowerCase() : vm.jobText.toLowerCase()
        if (filtStr.indexOf(filtVal) > -1) {
          a[i].style.display = ''
        } else {
          a[i].style.display = 'none'
        }
      })
    }
  }
}
</script>

<style lang="scss">
.searchinput-wrap{
  @media screen and (max-width:576px) {
    .header_desc{
      color: #141E32 !important;
      margin-bottom: 10px;
      font-size: 18px;
      font-weight: bold;
    }
    .search-filt{
      .card{
        box-shadow: 0px 3px 6px #00000029;
      }
      .fa-chevron-up{
        display: none !important;
      }
      .fa-chevron-down{
        display: none !important;
      }
      .result-wrap{
        border-radius:0 !important;
        display: none;
        &.show{
          display:block;
          position: fixed;
          left: 0;
          top: 0;
          width: 100vw;
          padding: 0;
          margin: 0;
          max-height: 100vh !important;
          height: 100vh !important;
          z-index: 999;
          background: #fff;
        }
      }
      button{
        justify-content: center;
      }
    }
    .list-group{
      li{
        padding: 8px 0 !important;
      }
    }
    .inner-title{
      text-align: left;
      padding: 25px;
      font-size: 18px;
      color: #000;
      font-weight: bold;
    }
    #showArd1, #showArd2{
      .fa-times{
        float: right;
      }
    }
  }
}
</style>
